import { serviceKey, formServiceKey } from '../service';

export const endpointKeys = {
  copyFormsToTargetCompanies: [...serviceKey, 'copy-forms-to-target-companies'],
  createFormLinks: [...serviceKey, 'create-form-links'],
  createFormUsingTemplates: [...serviceKey, 'create-form-using-templates'],
  medicalHistoryAnswerOptionsToggle: [...serviceKey, 'toggle-medical-conditions'],
  onboardCompany: [...serviceKey, 'onboard-company'],
  syncMedicalConditions: [...serviceKey, 'medical-conditions'],
  updateCompanyConfig: [...serviceKey, 'update-company-config'],
  updateFavouriteStatus: [...serviceKey, 'update-favourite-status'],
  upsertForm: [...serviceKey, 'upsert-form'],
  createForm: [...serviceKey, 'create-form'],
  updateForm: [...serviceKey, 'update-form'],
  importEaglesoftMedicalHistoryForms: [...serviceKey, 'import-eaglesoft-medical-history-forms'],
  updateFormLocationAccess: [...serviceKey, 'update-form-location-access'],
  updateKioskListingStatus: [...serviceKey, 'update-kiosk-listing-status'],
  updateReviewRequiredFlagForForm: [...serviceKey, 'update-review-required-flag-for-form'],
  updateReviewRequiredFlagForFormV2: [...serviceKey, 'update-review-required-flag-for-form-v2'],
  deleteFormV2: [...serviceKey, 'delete-form-v2'],
  updateReviewRequiredFlagForPacket: [...serviceKey, 'update-review-required-flag-for-packet'],
  updateReviewRequiredFlagForPacketV2: [...serviceKey, 'update-review-required-flag-for-packet-v2'],
  createPacketV2: [...serviceKey, 'create-packet-v2'],
  updatePacketV2: [...serviceKey, 'update-packet-v2'],
  deletePacketV2: [...serviceKey, 'delete-packet-v2'],
  updatePacketLocationAccess: [...serviceKey, 'update-packet-location-access'],
  updateCompanyAssets: [...serviceKey, 'update-company-assets'],
  updateSubmissionsArchiveStatusV2: [...serviceKey, 'update-submissions-archive-status-v2'],
  updateSubmissionIsReadStatus: [...serviceKey, 'update-submission-is-read-status'],
  updateProviderDetailsForSubmission: [...serviceKey, 'update-provider-details-for-submission'],
  submissionPersonReconciliation: [...serviceKey, 'submission-person-reconciliation'],
  refreshSourceTenants: [...serviceKey, 'refresh-source-tenants'],
  uploadFormsForDigitization: [...formServiceKey, 'upload-forms'],
  updateDigitizationFeesCheck: [...formServiceKey, 'update-digitization-fees-check'],
  setFormSubmitFlag: [...formServiceKey, 'set-form-submit-flag'],
  createDigitizationProcess: [...formServiceKey, 'create-digitization-process'],
  updateNPWritebackStatus: [...formServiceKey, 'update-np-writeback-status'],
  updateProviderMapping: [...serviceKey, 'update-provider-mapping'],
  deleteProviderMapping: [...serviceKey, 'delete-provider-mapping'],
  updateFormName: [...serviceKey, 'update-form-name'],
  updateDismissedBanner: [...serviceKey, 'update-dismissed-banner-status'],
  updatePDFConfigurations: [...serviceKey, 'update-pdf-configurations'],
  updateAutoInsuranceVerificationStatus: [...serviceKey, 'update-auto-insurance-verification-status'],
};
